import React,{Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {fetchServices,fetchSubServices} from '../../store/services';
import ServiceCard from '../shared/ServiceCard';
import { ClipLoader } from 'react-spinners';

class Services extends Component {
    state = {
        loading:true,
        services:[],
        sub_services:[]
    };
    componentDidMount = async()=> {

        await this.props.fetchServices().catch(console.log);
        await this.props.fetchSubServices().catch(console.log);
        if(!this.props.loading){
            return this.setState({
                services:this.props.services,sub_services:this.props.sub_services,
                loading:false
            });
        };

    };
    componentDidUpdate(prevProps){
        if(this.props.services !== prevProps.services){
            this.setState({services:this.props.services});
        };
        if(this.props.sub_services !== prevProps.sub_services){
            this.setState({sub_services:this.props.sub_services});
        };
        if(this.props.loading !== this.state.loading){
            this.setState({loading:this.props.loading})
        }
    }
    render(){
    return (
        <div className="services">
        <div className="row">
            <div className="col-12 col-sm-12 col-md-12">
                 <div className="services_heading">
                     <h3>Services Offerred</h3>
                     <div className="services_divider" />
                 </div>
            </div>
            {
                this.state.loading ? (
                    <div className="col-12 col-sm-12 col-md-12 text-center">
                        <ClipLoader size="30" color="#009933"/>
                    </div>
                ): (
                    this.state.services.length > 0 ? (
                        this.state.services.map((service,index) => (
                            <div className="col-12 col-sm-4 col-md-4" key={index}>
                                <ServiceCard data={service}/>
                            </div>
                        ))
                    ):(
                        <div className="col-12 col-sm-12 col-md-12 text-center">
                            <h4>No services uploaded yet!!</h4>
                        </div>
                    )
                )
            }
            {
                this.state.sub_services.length > 0 ? (
                <div className="col-12 col-sm-12 col-md-12 text-center services_link">
                <Link to="/sub_services" className="btn btn-outline-success">view more</Link>
                </div>
                ) : null
            }                    
                </div>
            </div>
    )
}};
const mapToProps = state => ({
    loading:state.services.loading,
    services:state.services.services,
    sub_services:state.services.sub_services
});
const dispatchToProps = {
    fetchServices,
    fetchSubServices
};
export default connect(mapToProps,dispatchToProps)(Services);